import { styled } from '@mui/material';

import { useMemo } from 'react';

import { useI18n } from '@app-velocity/i18n';

import { PersonaAvatar } from '../PersonaAvatar';

export const StyledSinglePersona = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

const StyledName = styled('span')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  lineHeight: 'normal',
});

const StyledBadge = styled('div')(({ theme }) => ({
  background: 'var(--background-background-secondary-color)',
  padding: `0 ${theme.spacing(2)}`,
  border: '1px solid var(--stroke-stroke-primary-color)',
  color: 'var(--text-text-tertiary-color)',
  borderRadius: theme.spacing(5),
  fontWeight: 500,
  fontSize: 11,
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export type SinglePersonaProps = {
  value: string;
  label?: string;
  legacy?: boolean;
};

export const SinglePersona = ({ value, label, legacy }: SinglePersonaProps) => {
  const { t } = useI18n();

  const displayName = useMemo(() => {
    if (label) return label;

    if (value === 'default') return t('prototypes:personas.default');

    if (value === 'accessible') return t('prototypes:personas.accessible');

    return '-';
  }, [value, label, t]);

  return (
    <StyledSinglePersona>
      <PersonaAvatar name={value} />
      <StyledName>{displayName}</StyledName>
      {legacy && <StyledBadge>Legacy</StyledBadge>}
    </StyledSinglePersona>
  );
};
